"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _datePicker = require("../basic/date-picker");

var _datePicker2 = _interopRequireDefault(_datePicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var DatePicker = _react2["default"].createClass({
	displayName: "DatePicker",
	onChange: function onChange(value) {
		var format = this.props.format || "yyyy/MM/dd";
		format = format.replace("yyyy", value.getFullYear());
		format = format.replace("MM", value.getMonth() + 1 < 10 ? "0" + String(value.getMonth() + 1) : value.getMonth() + 1);
		format = format.replace("dd", value.getDate() < 10 ? "0" + String(value.getDate()) : value.getDate());
		this.props.onChange(format);
	},
	render: function render() {
		return _react2["default"].createElement(_datePicker2["default"], _extends({}, this.props, { onChange: this.onChange }));
	}
});

DatePicker.Calendar = _datePicker2["default"].Calendar;
DatePicker.RangePicker = _datePicker2["default"].RangePicker;
DatePicker.MonthPicker = _datePicker2["default"].MonthPicker;

exports["default"] = DatePicker;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./components/business/datepicker.jsx
 ** module id = 279
 ** module chunks = 0
 **/